export default __webpack_public_path__ + "static/media/how-to-find-a-product-v2.62ccfe04.png";